import { useState, useEffect } from 'react';
import { notify } from '../utils/utils';
import { Fetch } from '../services/api';


export const useEmpresas = () => {
    const [ empresas, setEmpresas ] = useState([]);
    
    useEffect(() => {
        obtenerEmpresas();
    }, []);

    const obtenerEmpresas = async () => {

        const response = await Fetch({
            url: 'https://empresawebapi.abexacloud.com/api/Empresa/listaEmpresa'
        });

        if (response.isValid){
            setEmpresas(response.content);
        }else{
            notify(response.content)
        }
    }

    return { empresas, obtenerEmpresas }
}